/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';
/**
 * Module that holds the search overlay for both cars and appliance marketplaces.
 */

const categoriesModule = require('@utils/categories/categoriesModule');
const commonModule = require('@utils/common/commonModule');
const filtersModule = require('@utils/filters/filtersModule');
const utilitySelectorModule = require('@utils/utility_selector/utilitySelectorModule');

const SearchService = require('./searchService');

const searchModule = angular
    .module('enervee_utils.search', [
        categoriesModule.name,
        commonModule.name,
        filtersModule.name,
        utilitySelectorModule.name,
    ])
    .factory('SearchService', SearchService);

module.exports = searchModule;